import React from "react";

/**
 * Handles change of line height for text block.
 *
 * @param {string}   view     String for mobile or desktop view
 * @param {Object}   canvas   FabricJS Canvas Object
 *
 * @returns {Object}
 */
export default function LineHeight({ view, canvas }) {
  const changeLineHeight = () => {
    const className = view == "mobile"
      ? ".details-container-mobile"
      : ".details-container-inner";
    const height = document.querySelectorAll(className + " #lineHeight")[0] || null;
    const activeObject = canvas.getActiveObject() || null;
    if (activeObject === null || height === null) {
      return;
    }
    activeObject.set('lineHeight', height.value);
    canvas.renderAll();
  }

  return (
    <div id="lineHeightTool" className="text-tool-inner">
      <label htmlFor="lineHeight">Line Height</label>
      <input type="range" min="1" max="25" id="lineHeight" defaultValue="1" onChange={() => changeLineHeight()}></input>
    </div>
  );
}
